import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubMessage } from '../types/hub-message';
import { ErrorResponse } from '../types/standard-response';

@Component({
  selector: 'new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.css'],
  providers: [HubService],
})

export class NewMessageComponent implements OnInit, OnChanges {
  @Input() inHub: Hub;
  @Output() message_sent = new EventEmitter<boolean>();
  hub: Hub;
  message = new HubMessage();
  errorMessage: string;
  hubIdsArray: number[];
  messageSendFailed: boolean;
  messageFailMessage = 'Sending Message has failed for some unknown reason :-(';

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.message.created = new Date().toLocaleString();
    this.clear();
  }

  switchHub(): void {
    if (!this.inHub) { this.inHub = new Hub(); }
    this.hub = Object.assign({}, this.inHub);  // Clone

    try {
      this.message.hubid = this.hub.hubid.toString();
    } catch (e) { }

  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName of Object.keys(changes)) {
      // console.log('Property ' + propName + ' changed');
      switch (propName) {
        case 'inHub':
          this.switchHub();
          break;
      }
    }
  }

  isValid(): boolean {
    if (!this.message) { return false; }
    if (!this.message.from || this.message.from.length > 20) { return false; }
    if (!this.message.subject || this.message.subject.length > 18) { return false; }
    if (!this.message.body || this.message.body.length > 160) { return false; }
    if (this.message.mail_type > 0) {
      if (this.message.positive.length > 8 || this.message.positive.length < 1) {
        return false;
      }
      if (this.message.negative.length > 8 || this.message.negative.length < 1) {
        return false;
      }
    }

    return true;
  }

  clear() {
    this.message = new HubMessage();
    this.message.positive = 'Yes';
    this.message.negative = 'No';
    this.message.mail_type = 0;
    this.hubIdsArray = [];
  }

  cancel(): void {
    this.message_sent.emit(false);
  }

  parseHubIds(): void {
    this.hubIdsArray = this.message.hubid.split(/[;, \n]/).map(Number);
    console.log(this.hubIdsArray)
  }

  send(): void {
    let thisComponent = this;

    if (thisComponent.isValid() === false) {
      thisComponent.messageSendFailed = true;
      thisComponent.messageFailMessage = 'Fields are invalid!';
    }

    if (!!this.hub && !this.message.hubid) {
      this.message.hubid = this.hub.hubid.toString();
    }

    this.parseHubIds();
    this.hubService.sendMessage(this.hubIdsArray, this.message).subscribe(
      v => {
        console.log(v);
        if (v && v.status === 'success') {
          this.message_sent.emit(true);
          thisComponent.clear();
        } else {
          thisComponent.messageSendFailed = true;
          thisComponent.messageFailMessage = (<ErrorResponse>(v)).data.attributes.message;
        }
      },
      e => {
        thisComponent.messageSendFailed = true;
        thisComponent.messageFailMessage = `Message sending failed due to server error.`;
        console.log("Error sending message:\n" + JSON.stringify(e, null, "  "));
        thisComponent.messageFailMessage = `Message sending failed due to server error, status ${e.status}: ${e.statusText}`;
      }
    );
  }

}
